import { PremiumFeature } from '../proto/generated/subscription'
import { FeatureName } from '../components/adminUserRestrictions/Restrictions.constants'

export const hasFeatureAccess = (
    premiumFeatures: PremiumFeature[] | undefined,
    userFeatures: PremiumFeature[] | undefined,
    category: string,
    subCategory?: string,
    feature?: string
): boolean => {
    const matches = (f: PremiumFeature) =>
        f.category?.toUpperCase() === category.toUpperCase() &&
        (!subCategory || f.subCategory?.toUpperCase() === subCategory.toUpperCase()) &&
        (!feature || f.feature?.toUpperCase() === feature.toUpperCase())

    const isPremium = premiumFeatures?.some(matches) ?? false
    const userHasFeature = userFeatures?.some(matches) ?? false
    if (isPremium && !userHasFeature) {
        return false
    }
    return true
}

/** Same fail-closed pattern as Android: gate by featureCode (Feature column can be empty). */
export const hasFeatureAccessByCode = (
    premiumFeatures: PremiumFeature[] | undefined,
    userFeatures: PremiumFeature[] | undefined,
    featureCode: string
): boolean => {
    const code = featureCode.toUpperCase()
    const matches = (f: PremiumFeature) => f.featureCode?.toUpperCase() === code
    const isPremium = premiumFeatures?.some(matches) ?? false
    const userHasFeature = userFeatures?.some(matches) ?? false
    if (isPremium && !userHasFeature) {
        return false
    }
    return true
}

/** Product admin entitlement (ADMIN plan feature). Not identity ADMIN role. */
export const hasAdminAccessFeature = (
    premiumFeatures: PremiumFeature[] | undefined,
    userFeatures: PremiumFeature[] | undefined
): boolean =>
    hasFeatureAccessByCode(premiumFeatures, userFeatures, FeatureName.ADMIN_ACCESS)
